<template>
  <v-app>
    <v-app-bar
      app
      dark
      color="primary"
    >
      <v-toolbar-title>USPack Delivery</v-toolbar-title>
      <v-spacer />
      <router-link
        v-if="isResultsPage"
        :to="search"
      >
        <v-btn color="primary">
          Back to search
        </v-btn>
      </router-link>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'App',
    data: () => ({
        //
    }),
    computed: {
        search() {
            return `/${this.$route.path.split('/')[1]}`;
        },
        isResultsPage() {
            const results = this.$route.path.split('/');
            return results.length > 2;
        },
        parentPath() {
            const currentPath = this.$route.path;
            return currentPath.substring(0, currentPath.lastIndexOf('/'));
        }
    }
  });
</script>